import HelpService from './HelpService.vue';

export default HelpService;
